import React, { useState } from "react";
import Spinner from "../reusables/spinner";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import {
  approve_supplier,
  update_payment_status,
  verify_customer,
} from "../../redux/actions/adminActions";

function ConfirmModal({
  show,
  handleClose,
  users,
  status,
  payment,
  customer,
  updatePaymentStatus,
  accessToken,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleLoading = () => {
    setIsLoading(true);

    setTimeout(() => setIsLoading(false), 5000);
  };

  const handleApprove = (id) => {
    handleLoading();
    updatePaymentStatus(id, status, accessToken, handleClose);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
        <i class="ri-close-line sectionText--small"></i>
      </div>
      <div className="sectionHeight--mid center">
        <div className="w-100 vAlign">
          <h2 className="sectionText--mid">
            Are you sure you want to proceed?
          </h2>

          <div className="pt-3 center">
            {isLoading ? (
              <div className="center">
                <Spinner dark />
              </div>
            ) : (
              <div>
                <button
                  className="btn__filled mx-2 hasRadius"
                  onClick={handleClose}
                >
                  No, Cancel
                </button>
                <button
                  className="btn__transparent"
                  onClick={() => handleApprove(payment)}
                >
                  Yes, {customer ? "Verify" : "Confirm"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  updatePaymentStatus: (id, status, token, success) =>
    dispatch(update_payment_status(id, status, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);
